import React from 'react';
import { Loader, ProgressBar } from '@fourthwall/components';
import * as S from './MailchimpSyncJobActive.styled';
export const MailchimpSyncJobActive = ({ status }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(Loader, { size: "small" }),
            "Syncing data..."),
        React.createElement(S.StatusList, null, status.map((item) => {
            const percentage = item.total > 0 ? (item.progress / item.total) * 100 : 0;
            const isComplete = percentage === 100;
            const isPending = item.total === 0;
            return (React.createElement(S.StatusItem, { key: item.key },
                React.createElement(S.StatusLabel, null, item.key),
                item.total > 0 ? (React.createElement(ProgressBar, { value: percentage, max: 100 })) : (React.createElement(ProgressBar, { value: 0, max: 100 })),
                isComplete && React.createElement(S.ProgressText, null, "Completed"),
                isPending && (React.createElement(S.PendingContainer, null,
                    React.createElement(Loader, { size: "small" }),
                    " pending...")),
                !isComplete && !isPending && (React.createElement(S.ProgressText, null,
                    item.progress,
                    " / ",
                    item.total,
                    " (",
                    Math.round(percentage),
                    "%)"))));
        }))));
};
